import { createAction } from '@reduxjs/toolkit';

export const fetchingTenant = createAction('FETCH_TENANT_LIST_INIT');
export const fetchedTenantSuccess = createAction<Array<Object>>('FETCH_TENANT_LIST_SUCCESS');
export const fetchedTenantFailed = createAction('FETCH_TENANT_LIST_FAILED');
export const SEARCH = createAction<string>('SEARCH')
export const updateFreshworksAccountAction = createAction<Object>('UDPATE_FRESHWORKS_ACCOUNT');
export const updateFreshworksAccountActionSuccess = createAction<any>('UPDATE_FRESHWORKS_ACCOUNT_SUCCESS');
export const syncFreshworksUsersAction = createAction<any>('SYNC_FRESHWORKS_USERS')